import { Layout } from "@/components/Layout";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { NewsletterDialog } from "@/components/NewsletterDialog";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Newsletter() {
  const { t } = useLanguage();

  return (
    <Layout>
      <Helmet>
        <title>Newsletter — HIDNstock</title>
        <meta name="description" content="Sign up for the HIDNstock newsletter and get updates on sorted secondhand, excess inventory and remake projects in our B2B marketplace." />
        <link rel="canonical" href="https://hidnstock.com/newsletter" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://hidnstock.com/newsletter" />
        <meta property="og:title" content="Newsletter — HIDNstock" />
        <meta property="og:description" content="Sign up for the HIDNstock newsletter." />
      </Helmet>
      <section className="py-24 md:py-32">
        <div className="container mx-auto px-6 lg:px-8 max-w-2xl text-center">
          <h1 className="text-4xl md:text-6xl font-black uppercase mb-6">{t("newsletter.title")}</h1>
          <p className="text-lg text-muted-foreground mb-10">{t("newsletter.pageIntro")}</p>
          <NewsletterDialog>
            <Button size="lg" className="uppercase">{t("newsletter.signUp")}</Button>
          </NewsletterDialog>
        </div>
      </section>
    </Layout>
  );
}
